// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4045":"20aafaa8","5076":"d1e891da"}[chunkId] + ".chunk.css";
};